import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../../actions';

import Summary from './Summary';

const mapStateToProps = state => {
  const { reportName, reportDescription } = state.reports;
  return {
    reportDescription,
    reportName
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Summary);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/SummaryContainer.js